/**
 * ルーターの認証ガードを、有限時間で必ず終わらせる（指示書 A-1②、A-06・A-25）。
 *
 * ガードの中の通信（認証・プロフィール・契約・LINE）が返ってこないと、遷移が終わらず、
 * 初回表示ではスピナーのまま、ログイン後は押したボタンのまま止まって見える。
 * 期限を過ぎたら、回復画面（/connection-error）へ確定した出口を用意する。
 * 期限後に元のガードが遅れて next を呼んでも、無視する（古い結果で、新しい状態を上書きしない）。
 */

export const GUARD_DEADLINE_MS = 15000
export const CONNECTION_ERROR_PATH = '/connection-error'

/**
 * @param {(arg?: any) => void} next  vue-router の next
 * @param {{ timeoutMs?: number, onTimeout: () => any, setTimeoutFn?: typeof setTimeout, clearTimeoutFn?: typeof clearTimeout }} opts
 *   onTimeout: 期限を過ぎたときに next に渡す値（回復画面への行き先など）
 */
export function createGuardSettler(next, { timeoutMs = GUARD_DEADLINE_MS, onTimeout, setTimeoutFn = setTimeout, clearTimeoutFn = clearTimeout }) {
  let settled = false
  let timedOut = false
  const timer = setTimeoutFn(() => {
    if (settled) return
    settled = true
    timedOut = true
    let target
    try { target = onTimeout() } catch (_) { target = undefined }
    next(target)
  }, timeoutMs)

  return {
    /** 元のガードが呼ぶ next。2回目以降・期限後は無視する */
    next(arg) {
      if (settled) return false
      settled = true
      clearTimeoutFn(timer)
      next(arg)
      return true
    },
    get settled() { return settled },
    get timedOut() { return timedOut }
  }
}

/**
 * 回復画面から戻る先として使ってよい、アプリ内のパスだけを返す。
 * 外部URL・プロトコル相対（//）・hash（パスワード再設定のトークン等）は使わない。
 */
export function safeInternalReturnPath(raw, fallback = '/top') {
  const s = typeof raw === 'string' ? raw : ''
  if (!s.startsWith('/') || s.startsWith('//') || s.startsWith('/\\')) return fallback
  const withoutHash = s.split('#')[0]
  const path = withoutHash.split('?')[0]
  if (!path || path === CONNECTION_ERROR_PATH) return fallback
  if (/[\s<>"']/.test(withoutHash)) return fallback
  return withoutHash
}
